<template>
  <CCard>
    <CCardHeader>
      <strong>Reported Question</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <span>Type : {{report.type}}</span>
        </CCol>
        <CCol sm="12">
          <span>Question : {{report.question.english}}</span>
        </CCol>

        <CCol sm="12" v-if="report.user != null">
          <span>Reported By : {{report.user.name}} {{report.user.phone}}   </span>
        </CCol>
        <CCol sm="12">
            <router-link :to="{ name: 'QuestionEdit', params: {id: report.question_id}}">Click to go to the question
            </router-link>
        </CCol>
        <CCol sm="12">
          <div>
            <span>Status :</span><br>
            <input class="m-1" type="radio" value="pending" v-model="report.status">
            <label class="text-danger">Pending</label>
            <input class="m-1" type="radio" value="resolved" v-model="report.status">
            <label class="text-success">Resolved</label>
          </div>
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle"/> Update Report </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL
export default {
  name: "QuestionReportEdit",
  data() {
    return {
      report : {}
    }
  },
  created() {
    this.getReport()
    this.getCategories()
  },
  methods : {
    getReport() {
      this.$axios
          .get(`${ADMIN_URL}/question-reports/${this.$route.params.id}`)
          .then((response) => {
            this.report = response.data
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          'Accept' : 'application/json',
        }
      };

      let data = {}
      data.status = this.report.status
      data.type = this.report.type
      data._method = 'patch'


      this.$axios.post(`${ADMIN_URL}/question-reports/${this.$route.params.id}`,data)
          .then(response => {
            console.log('Success', response);
            currentObj.success = response.data.success;
            console.log(response.data);
            this.$swal('Success',response.data.message,'success');
          })
          .catch(error => {
            console.log('Error  ... ', error.response);
            currentObj.output = error;
            this.$swal('Error',error.response.message,'error');
          });
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
